import { Box, Grid, InputAdornment, makeStyles, TextField, Typography } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { format } from "date-fns";
import Tabs from "features/Tabs/Tabs";
import React, { useCallback, useEffect, useState } from "react";
import DateRangePickerTDSAT from "./DateRangePickerTDSAT";
import debounce from "lodash.debounce";
import Axios from "axios";
import CircularCenteredLoader from "features/common/CircularCenteredLoader";
import { getTdsatCasesBySearch, getTdsatCounts } from "./API/TdsatApi";
import { Pagination } from "@material-ui/lab";
import { noCaseFoundText } from "./TdsatContainer";

const useStyles = makeStyles((theme) => ({
	root: {
		padding: '1.5rem',
		width: '100%',
    	boxSizing: 'border-box',
	},
  formControl: {
    minWidth: 120,
		padding: '5px 10px',
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
	searchbar: {
		width: "-webkit-fill-available",
		color: "#828282",
		fontSize: "14px",
		outline: "none",
		padding: "0rem 1.5rem",
		height: "42px",
		[theme.breakpoints.down("xs")]: {
			fontSize: "12px",
			height: "34px",
			padding: "0rem 0.7rem",
		},
	},
	tabsContainerMain: {
		width:'100%',
		flexWrap: 'nowrap',
		[theme.breakpoints.down("sm")]: {
			flexWrap: 'wrap',
		},
	},
	selectedMainTab: {
		padding: "0.8rem 1.5rem",
		cursor: 'pointer',
		fontSize: '1.2rem',
		fontFamily: 'Satoshi-Medium',
		whiteSpace: 'pre-line',
		color: theme.palette.primary.main,
		borderBottom: `2px solid ${theme.palette.primary.main}`,
	},
	unselectedMainTab: {
		fontSize: '1.2rem',
		padding: "0.8rem 1.5rem",
		cursor: "pointer",
		fontFamily: 'Satoshi-Medium',
		whiteSpace: 'pre-line',
		borderBottom: '2px solid black',
	},
	tableHeadItem:{
		// color: 'grey',
		fontSize: '15px',
		fontFamily: 'Satoshi-Bold',
	},
	tableRowValue: {
		// color: '#858D98',
		fontSize: '14px',
	},
	valuePaper: {
		padding: "1.5rem 0",
		cursor: "pointer",
		boxShadow: "none",
		width: "100%",
		border: "1px solid #E0E0E0",
		"&:hover": {
			background: "#E5F6EF",
			'& $downloadButton': {
				visibility: 'visible',
			}
		},
		[theme.breakpoints.down("sm")]: {
			textAlign: "center",
		},
	},
  filtersContainer: {
    padding: '8px', 
    borderBottom: '1px solid black', 
    display: 'flex', 
    gap: '15px', 
    justifyContent:'center',
    width: '80%',
    margin: 'auto',
  },
}));

export default function PreviouslyFiledCases(){
	const classes = useStyles();
	const [previouslyFiledCases, setPreviouslyFiledCases] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [cancelToken, setCancelToken] = useState();
	const [loading, setLoading] = useState(false);
	const [activeTabMain, setActiveTabMain] = useState('main_cases');
  const [counts, setCounts] = useState({ main_cases: '--', applications: '--', documents: '--', caveats: '--', court_fees: '--'});
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);

  const debouceSearch = useCallback(debounce(search, 500), [previouslyFiledCases]);

  const spacing = [1,1,2,2,2,2,2];
  const tableHeadings = ['Sr. No.','Diary No.','Case Type','Case No.','Parties Name','Date of Filing','Registration Date'];
  const DASHBOARD = 'registered_cases';
  const PAGE_SIZE = 10;

  const processResponse = (data, current_page = page) => {
    const response = data;
    const tempArr = response.map((item,index) => {
      const arr = [
				(PAGE_SIZE * (current_page - 1) + (index + 1)), 
				item.diary_number, 
				item.case_type_new, 
				item.case_number, 
				item.name, 
				format(new Date(item.case_creation_date_time), "dd/MM/y"), 
				format(new Date(item.registration_date_time), "dd/MM/y")
			];
      return arr;
    })
    return tempArr;
  }

  const reload = (searchValue='', current_page=page, start=null, end=null, cancelToken='') => {
		setLoading(true);
		getTdsatCasesBySearch(DASHBOARD, activeTabMain, current_page, PAGE_SIZE, searchValue, cancelToken, start, end)
    .then((res)=>{
      const response = res?.data?.results;
      const processedResponse = processResponse(response, current_page);
      setPreviouslyFiledCases(processedResponse);
      let count = res?.data?.count;
      let t = parseInt(count / PAGE_SIZE);
      let r = count % PAGE_SIZE;
      let total = t + (r > 0 ? 1 : 0);
      setTotalPages(total);
      setLoading(false);
    })
  }

  useEffect(()=>{
    getTdsatCounts(DASHBOARD).then((res)=>{
      const count = res.data;
      setCounts(count);
    })
  },[])

  useEffect(()=>{
		search(searchText);
  },[startDate,endDate, activeTabMain])

  function search(value) {
    //Check if there are any previous pending requests
    if (typeof cancelToken != typeof undefined) {
      cancelToken.cancel("Operation canceled due to new request.");
    }
    //Save the cancel token for the current request
    let x = Axios.CancelToken.source();
    setCancelToken(x);
    const start = startDate ? format(startDate,'dd-MM-yyyy') : startDate;
    const end = endDate ? format(endDate,'dd-MM-yyyy') : endDate;
    setPage(1);
    if( (start && end) || (start === null && end === null)) {
      reload(value.trim(),1,start,end,x);
		}
  }

  const mainTabs = [
		{
			id: "main_cases",
			label: "Main Case " + counts?.main_cases,
		},
		{
			id: "applications",
			label: "Application " + counts?.applications,
		},
		{
			id: "documents",
			label: "Document " + counts?.documents,
		},
		// {
		// 	id: "caveats",
		// 	label: "Caveat " + counts?.caveats,
		// },
    {
			id: "court_fees",
			label: "FDR/Cost Deposit Details " + counts?.court_fees,
		},
	];

  const handleMainTabChange = (newValue) => {
		setActiveTabMain(newValue);
    setSearchText('');
    setStartDate(null);
    setEndDate(null);
    setPage(1);
	};

  const handlePageChange = (event,value) => {
    if(page === value){
      return;
    }
    setPage(value);
		const start = startDate ? format(startDate,'dd-MM-yyyy') : startDate;
    const end = endDate ? format(endDate,'dd-MM-yyyy') : endDate;
    reload(searchText, value, start, end);
  }

    return (
			<Box className={classes.root}>
        <Typography align="center" style={{fontSize:'1.5rem', marginBottom: '48px'}}>
					PREVIOUSLY FILED CASES
				</Typography>
        <Tabs
					tabs={mainTabs}
					handleClickTab={handleMainTabChange}
					choice={activeTabMain}
					tabsClasses={{
						selected: classes.selectedMainTab,
						unselected: classes.unselectedMainTab,
					}}
					tabsContainerClass={classes.tabsContainerMain}
				/>
				<Box style={{height:'2rem'}}/>
				<Box className={classes.filtersContainer}>
          <TextField
            size="small"
            style={{flex: 1}}
            variant="outlined"
            placeholder="Search by Party Name, Dairy No., Case No."
						value={searchText}
						onChange={(e) => {
							setSearchText(e.target.value);
							debouceSearch(e.target.value);
						}}
						onBlur={(e) => {
							e.target.placeholder =
								"Search by Party Name, Dairy No., Case No."
						}}
						InputProps={{
							endAdornment: <InputAdornment position="end"><Search/></InputAdornment>,
						}}
          />
          <DateRangePickerTDSAT startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate}/>
        </Box>
				<Box style={{height:'1rem'}}/>
				<Box>
					<Box style={{height: '2rem'}}/>
					<Grid container style={{ rowGap: "8px" }}>
						<Box style={{padding:'1.5rem 0', width: '100%'}}>
							<Grid container spacing={2} justifyContent="flex-start">
                {tableHeadings.map((heading,index)=>{
                  return (
                    <Grid key={index} item xs sm={spacing[index]}>
                      <Typography className={classes.tableHeadItem}>
                        {heading}
                      </Typography>
                    </Grid>
                  )
                })}
							</Grid>
						</Box>
						{loading ? (
							<Box style={{margin:'auto',width:'100%'}}>
							<CircularCenteredLoader/>
						</Box>
						) : (
							previouslyFiledCases.length !== 0 ? (
								previouslyFiledCases.map((dispute,index) => {
									return (
										<Box key={index} className={classes.valuePaper}>
											<Grid container spacing={2} justifyContent="flex-start">
												{dispute.map((item,index)=>{
													return (
														<Grid key={index} item xs sm={spacing[index]}>
															<Typography className={classes.tableRowValue}>
																{item}
															</Typography>
														</Grid>
													)
												})}
											</Grid>
										</Box>
									);
								})
							) : (
								<Grid container justifyContent="center">
									<Grid item xs>
										<Box textAlign="center">
											<Typography>
												{noCaseFoundText(activeTabMain)}
											</Typography>
										</Box>
									</Grid>
								</Grid>
							)
						)}
						{previouslyFiledCases.length !== 0 && (
              <Box style={{padding:'16px'}}>
                <Pagination color="primary" count={totalPages} page={page} onChange={handlePageChange}/>
              </Box>
            )}
					</Grid>
				</Box>
			</Box>
    )
}